import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useFilterParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleFilterChange = (key: string, value?: string | null) => {
    setSearchParams(prevParams => {
      const newParams = new URLSearchParams(prevParams);
      if (!value) newParams.delete(key);
      else newParams.set(key, value);

      return newParams;
    });
  };

  return { searchParams, handleFilterChange, setSearchParams };
};

// use case: when searching something inside modal
// problem is that you can't use upper useFilterParams in main page and inside modal because that is the same instance "searchParams" for both of them: main page & modal
// Solution: Keep the main "searchParams" & use local state for the modal
export const useFilterParamsModal = () => {
  const [modalSearchParams, setModalSearchParams] = useState(new URLSearchParams());

  const handleFilterChangeModal = (key: string, value: string) => {
    setModalSearchParams(prevParams => {
      const newParams = new URLSearchParams(prevParams);
      newParams.set(key, value);

      return newParams;
    });
  };

  return { modalSearchParams, handleFilterChangeModal, setModalSearchParams };
};
